import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import InspectionItem from "../../components/InspectionItem";
import { sortByOrderType } from "../../helpers/sortByOrderType";
import { booksLoad } from "redux/actions/books/booksLoad";
import Loading from "shared/components/Loading";

import ListHeader from "components/ListHeader";
import inspectionsArchivedLoad from "redux/actions/audit/inspectionsArchivedLoad";

import "./style.scss";

export default function InspectionsArchived() {

    const [t] = useTranslation();
    const dispatch = useDispatch();
    const audit = useSelector(state => state.audit);
    const { loading } = useSelector(state => state.audit);

    const [sortIndex, setSortIndex] = useState(0);
    const [sortDirection, setSortDirection] = useState(false);

    const { archived: inspections } = audit;

    const HEADERS = [
        { field: "organisation", label: t("organisation.singular") },
        { field: "location", label: t("audit.location.singular") },
        { field: "book", label: t("audit.book.singular") },
        { field: "lastAudit", label: t("audit.last") },
    ];

    useEffect(() => {
        dispatch(booksLoad());
        dispatch(inspectionsArchivedLoad());
    }, [dispatch]);

    const sortItems = (items) => {
        return Array.isArray(items) && sortIndex
            ? sortByOrderType(HEADERS, items, sortIndex, sortDirection) : items;
    };

    const onSort = (idx) => {
        setSortDirection(!sortDirection);
        setSortIndex(idx);
    };

    const renderInspections = () => {
        const keys = Object.keys(inspections || {});

        if (keys.length === 0) {
            return (
                <span className="container-empty">
                    {t("audit.inspections.empty")}
                </span>
            );
        } else {
            const inspectionsArray = keys.map((key) => { return inspections[key]; });
            return sortItems(inspectionsArray).map((item, index) => {
                return (
                    <InspectionItem
                        archived
                        key={index}
                        index={index}
                        item={item}
                    />
                );
            });
        }
    };

    return (
        <div className="inspection-overview">
            <h2>{t("audit.inspections.archived.title")}</h2>
            <div className="spacer-double" />
            <div className="filter-divider" />
            <div className="spacer" />
            {loading ?
                <Loading /> :
                <>
                    <ListHeader
                        onSort={onSort}
                        items={HEADERS}
                        sortIndex={sortIndex}
                        sortDirection={sortDirection}
                    />
                    <div className="inspection-list-items">
                        {renderInspections()}
                    </div>
                </>
            }
        </div>
    );
}